import { Trans } from '@lingui/macro'
import { useGlobals } from 'context'
import React, { useEffect, useState } from 'react'
import { Loading, Paper } from 'webbook-airways'
import { help } from '../api/help'

export default function HelpLoader({ type, id, show, style }) {
  const { createError } = useGlobals()
  const [isLoading, setIsLoading] = useState(false)
  const [helpObject, setHelpObject] = useState({})

  useEffect(() => {
    if (type && id && show) {
      getHelp()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id, show])

  async function getHelp() {
    setIsLoading(true)
    try {
      const response = await help(id, type)
      setHelpObject(response.data?.response.page)
    } catch (error) {
      createError(error, <Trans>Unable to get help</Trans>)
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) {
    return <Loading size={24} noTimeout container />
  }

  if (show) {
    return (
      <Paper
        style={{
          padding: '5px 15px',
          fontFamily: 'Inter',
          fontSize: '0.7em',
          ...style
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: helpObject.content }} />
      </Paper>
    )
  } else {
    return null
  }
}
